// /p/:projectId/*: opens the project (POST /api/me/project checks access and
// makes it current), then gives every page useProject(): the project, the
// person's role there and can(action). No access = the not-found page (404,
// never "forbidden": SPEC-v3 2.2).
import { useEffect, useMemo } from "react";
import { Outlet, useParams } from "react-router";
import { ApiError } from "../api/client";
import { makeScope, ProjectContext, rememberProject, useProjectAccess } from "../api/project";
import { Loading, NotFoundContent, PageError } from "../ui/QueryStates";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function ProjectScope() {
  const { projectId = "" } = useParams();
  const valid = UUID.test(projectId);
  const access = useProjectAccess(valid ? projectId : undefined);
  const scope = useMemo(() => (access.data ? makeScope(projectId, access.data) : null), [access.data, projectId]);

  useEffect(() => {
    if (scope) rememberProject(projectId);
  }, [scope, projectId]);

  if (!valid) return <NotFoundContent />;
  if (access.isPending) return <Loading />;
  if (access.isError) {
    if (access.error instanceof ApiError && (access.error.status === 404 || access.error.status === 403)) return <NotFoundContent />;
    return <PageError error={access.error} />;
  }
  return (
    <ProjectContext.Provider value={scope}>
      <Outlet />
    </ProjectContext.Provider>
  );
}
